/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaSelectOneAllOptions/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaSelectOneOptionMulti from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/TysiaSelectOneOption/TysiaSelectOneOptionMulti/index'
import TysiaSelectOneOptionMultiInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/TysiaSelectOneOption/TysiaSelectOneOptionMulti/TysiaSelectOneOptionMultiInput/index'
import TysiaSelectOneOptionMultiText from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/TysiaSelectOneOption/TysiaSelectOneOptionMulti/TysiaSelectOneOptionMultiText/index'



/** @type {import('Simple/types.js').View} */
export default function TysiaSelectOneAllOptions({
  children,
  viewPath = "/DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/TysiaSelectOneAllOptions",
  size,
  onClickToggleAll,
  isSelectedAll,
  alignSelf,
  disabled
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaSelectOneOptionMulti
  viewPath={`${viewPath}/TysiaSelectOneOptionMulti`}
 size={size}
 onChange={onClickToggleAll}
 value={isSelectedAll}
 alignSelf={alignSelf}
 disabled={disabled}
 marginRight={dtSpaceXs}
 marginLeft={dtSpaceXs}
 marginTop={3}
 marginBottom={3}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneOptionMultiInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptionMultiInput`}
/>
<TysiaSelectOneOptionMultiText
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptionMultiText`}
 text="Select All"
/>
</React.Fragment>
)}
</TysiaSelectOneOptionMulti>
{children}
</React.Fragment>)
}